import React from "react";
import "./communityList.scss";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import CustomTab from "../../components/common/Tabs";
import Assosiated from "./communityTabs/Associated";
import NotAssociated from "./communityTabs/NotAssociated";
import { useParams } from "react-router-dom";
import { WORDPRESS_BASE } from "../../constants/api";

const bread = [
  {
    name: "Community List",
    link: "/community",
    isActive: true,
  },
];

const data = [
  {
    heading: "Communities Joined",
    key: 1,
    body: <Assosiated />,
  },
  {
    heading: "Not Yet A Member",
    key: 2,
    body: <NotAssociated />,
  },
];

function CommunityList() {
  const token = JSON.parse(localStorage.getItem("webUser"))?.data?.authToken;
  const params = useParams();

  return (
    <>
      <section className="communityList">
        <div className="container">
          <div className="breadcrumbsCommunity">
            <Breadcrumbs list={bread} />
          </div>
          <div className={token ? "communityHeader" : "communityheader"}>
            <div className="community-title">
              <h3>Community List</h3>
              <div className="learnMoreWrap">
                <a
                  className="learnTextLink"
                  href={WORDPRESS_BASE + "/communities/"}
                >
                  Learn More
                </a>
              </div>
            </div>

            <div className="communityTab">
              {token ? (
                <CustomTab
                  defaultIndex={params.id ? params.id - 1 : 0}
                  className="communityListTab"
                  data={data}
                  from="community"
                />
              ) : (
                <Assosiated guestUser={true} />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default CommunityList;
